import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import {NavLink} from "react-router-dom";
import FormDropdown from "../../../components/FormDropdown";
import DropdownView from "../Pantau/DropdownView";
import {SelectPanel, MultiSelect} from "@khanacademy/react-multi-select";

class Detail extends React.Component {
    constructor() {
        super();
        this.state = {
            exam_cat_id: 0,
            pageCount: 0,
            currentPage: 0,
            isLoading: false,
            isButtonLoading: false,
            isModalShow: false,
            isModalEditShow: false,
            question_id:"",
            score:0,
            question_type : "",
            participant_id : 29,
            dataParticipant : [],
            dataDetailExam : [],
            dataSiswa : [],
            nama:'',
            siswaSelect:[]
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleCetak = this.handleCetak.bind(this);
        this.handleSelected = this.handleSelected.bind(this);

    }

    handlePageClick(data) {
        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })

    }

    handleCetak() {
        this.setState({isButtonLoading: true});

        const url = "ujian/cetak-kartu";

        const params = qs.stringify({
            siswaSelect:this.state.siswaSelect
        });

        axios.post(url, params)
        .then(response => {
            const result = response.data;

            if (result.success) {
                Alert.success(result.message);
                console.log(result.data);
                this.setState({isButtonLoading: false});
            }
            else {
                if (Array.isArray(result.message)) {
                    result.message.map(item => {
                        Alert.error(item);
                        return true;
                    })
                }
                else {
                    Alert.error(result.message)
                }
                this.setState({ isButtonLoading: false })
            }
        })
        .catch(error => {
            this.setState({isButtonLoading: false})
            Alert.error("Gagal terhubung ke server!")
        })
    }

    loadData() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            exam_id: this.props.match.params.exam_id,
            user_id: localStorage.SISMART_USER_ID
        });

        axios({
            method: "post",
            url: '/ujian/'+this.props.match.params.exam_id+'?' + params,
        })
            .then(response => {
                const result = response.data;
                if (result.success === true) {
                    const dataParticipant = result.part.map(item => ({
                        key: item.participant_id,
                        value: item.kelas_nama
                    }));

                    this.setState({
                        dataDetailExam: result.data,
                        dataParticipant : dataParticipant,
                        isLoading: false
                    });

                } else {
                    Alert.error(result.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({ isLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });
    }

    loadDataSiswa() {
        this.setState({ isLoading: true });

        const params = qs.stringify({
            participant_id: this.state.participant_id,
            cari: this.state.nama
        });

        axios({
            method: "post",
            url: '/ujian/siswa-part?' + params,
        })
        .then(response => {
            const result = response.data;
            if (result.success === true) {
                this.setState({
                    dataSiswa: result.data,
                    isLoading: false
                });

            } else {
                Alert.error(result.message);
                this.setState({ isLoading: false });
            }
        })
        .catch(error => {
            this.setState({ isLoading: false });
            Alert.error("Gagal terhubung ke server!");
        });
    }

    handleSelected(siswaSelect) {
        this.setState({
            siswaSelect
        });
    }

    componentDidMount() {
        this.loadData();
        this.loadDataSiswa();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.participant_id !== this.state.participant_id || prevState.nama !== this.state.nama ) {
            this.loadDataSiswa();
        }

    }

    render() {
        const dataSiswa = this.state.dataSiswa.map(item => ({
            value: item.user_id,
            label: item.user_nama+' - '+item.kelas_nama
        }));

        const {siswaSelect} = this.state;

        return (
            <div>
                <div className="card" >
                    <div className="card-block">
                        <div className="col-md-12 form-group row">
                            <div className="col-md-6">
                                <DropdownView
                                    handleChange={this.handleChange}
                                    stateName="participant_id"
                                    label="Pilih Kelas Peserta"
                                    items={this.state.dataParticipant}
                                    value={this.state.participant_id}
                                />
                            </div>
                            <div className="col-md-6">
                                <input
                                    name="nama"
                                    type="text"
                                    className="form-control"
                                    placeholder="Ketikkan Nama Pengguna..."
                                    value={this.state.nama}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header">
                                <div style={{marginTop: "10px", display: "inline-block"}}>
                                    Detail Ujian
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table table-striped table-bordered animated fadeIn">
                                    <tr>
                                        <td width={200}>Judul</td>
                                        <td>{this.state.dataDetailExam.exam_title}</td>
                                    </tr>
                                    <tr>
                                        <td>Deskripsi</td>
                                        <td>{this.state.dataDetailExam.exam_desc}</td>
                                    </tr>
                                    <tr>
                                        <td>Tanggal Mulai</td>
                                        <td>{this.state.dataDetailExam.exam_start_date}</td>
                                    </tr>
                                    <tr>
                                        <td>Tanggal Selesai</td>
                                        <td>{this.state.dataDetailExam.exam_end_date}</td>
                                    </tr>
                                    <tr>
                                        <td>Durasi</td>
                                        <td>{this.state.dataDetailExam.exam_time_limit}</td>
                                    </tr>
                                    <tr>
                                        <td>Guru</td>
                                        <td>{this.state.dataDetailExam.user_nama}</td>
                                    </tr>
                                    <tr>
                                        <td>Mapel</td>
                                        <td>{this.state.dataDetailExam.mapel_nama}</td>
                                    </tr>
                                    <tr>
                                        <td>Soal</td>
                                        <td>{this.state.dataDetailExam.totQue}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-header">Peserta</div>
                            <div className="card-block" style={{ height:'600px', overflowX:'auto' }}>
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.dataSiswa.length === 0 ? "Data Kosong..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Siswa
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-sm float-right"
                                                        disabled={this.state.isButtonLoading && "disabled"}
                                                        onClick={this.handleCetak}
                                                    >
                                                    {
                                                        this.state.isButtonLoading ?
                                                            "Loading.."
                                                        : (
                                                                <a><i className="fa fa-print"></i> Cetak</a>
                                                        )
                                                    }
                                                    </button>
                                                </div>

                                                <SelectPanel
                                                    options={dataSiswa}
                                                    onSelectedChanged={this.handleSelected}
                                                    hasSelectAll
                                                    focusIndex={1}
                                                    selected={siswaSelect}
                                                    disableSearch={false}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/Detail.js